import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import ExternalCoursesAdmin from './ExternalCoursesAdmin';
import ExternalLearningAdmin from './ExternalLearningAdmin';

// Admin > External Courses: the Old Mutual course library plus third-party learning modules
export default function ExternalCoursesTab({ token }) {
  return (
    <div className="p-8" data-testid="external-courses-tab">
      <h2 className="font-heading text-2xl font-bold text-white mb-1">External Courses</h2>
      <p className="text-sm text-zinc-400 mb-6">Courses shown in the Course Catalogue under the External tab.</p>
      <Tabs defaultValue="library">
        <TabsList className="bg-zinc-800 mb-6">
          <TabsTrigger value="library" data-testid="ext-subtab-library">Old Mutual Library</TabsTrigger>
          <TabsTrigger value="modules" data-testid="ext-subtab-modules">Learning Modules</TabsTrigger>
        </TabsList>
        <TabsContent value="library"><ExternalCoursesAdmin token={token} /></TabsContent>
        <TabsContent value="modules"><ExternalLearningAdmin token={token} /></TabsContent>
      </Tabs>
    </div>
  );
}
